import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
export function CTASection() {
  return <section className="py-24 px-6 bg-luxury-black text-white relative overflow-hidden" data-id="element-77" data-mp="27hf50ky2lh7d">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-78" data-mp="2cefbuy2qunzj">
        <div className="absolute top-[-20%] right-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-79" data-mp="2hcqm39wyb0ia"></div>
        <div className="absolute bottom-[-20%] left-[-10%] w-96 h-96 bg-gold rounded-full filter blur-3xl" data-id="element-80" data-mp="2mc3gcfq5j9uw"></div>
      </div>

      <Watermark position="center" size={850} opacity={0.07} dark data-id="element-81" data-mp="2v5q0f8kzyoo9" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-82" data-mp="2v8kk2xw6s5gm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-83" data-mp="304t68v8swyxa">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-6" data-id="element-84" data-mp="217jkgi30r4h9">
            ELEVA TU IMAGEN PROFESIONAL HOY
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 font-sans font-light mb-10" data-id="element-85" data-mp="1r7iu4c6qfo3k">
            Haz que cada cita refleje organización, lujo y profesionalismo.
          </p>

          <motion.a href="#disponible-en" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold hover:bg-gold-light text-luxury-black font-sans font-bold text-lg tracking-widest uppercase px-12 py-5 rounded-sm transition-colors duration-300 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-86" data-mp="2jwq4c8fju24n">
            ORDENAR MI KIT
          </motion.a>
        </motion.div>
      </div>
    </section>;
}